<template lang="pug">
v-container
  h1 Ошибки пользователей
  div
    v-btn(color="primary" @click="refresh") Перезапустить все
  smart-table(
    :headers="headers"
    :adapter="adapter"
    hide-search-actions
    hide-expand
    isLocalPagination
    isLocalFilter
  )
    template(#value--view="{ item }")
      router-link(:to="{ name: 'error-details', params: { id: item.user_id }}" target="_blank")
        v-icon(color="primary" small) mdi-eye
    template(#value--error="{ item }")
      span: strong {{ item.error.length }}
    template(#value--status="{ item }")
      v-chip(:color="item.status ? 'success' : 'error'") {{ item.status ? 'В работе' : 'Ошибка' }}
    template(#value--actions="{ item }")
      v-btn.mr-2(color="success" @click="startNode(item.user_id)") Начать обработку
      v-btn(color="error" @click="stopNode(item.user_id)") Закончить обработку
</template>
<script>
import service from '@/services/API/letter-handler';
import SmartTable from '@/components/SmartTable/index.vue';

export default {
  name: 'AutoAnsewerSettings',
  components: {
    SmartTable,
  },
  data() {
    return {
      selectedTab: 0,
      node: [],
      headers: [
        {
          text: '',
          value: 'view',
        },
        {
          text: 'id Пользователя',
          value: 'user_id',
          searchable: true,
        },
        {
          text: 'Почта',
          value: 'email',
          searchable: true,
        },
        {
          text: 'Ошибок',
          value: 'error',
        },
        {
          text: 'Статус',
          value: 'status',
        },
        {
          text: '',
          value: 'actions',
        },
      ],
    };
  },

  methods: {
    adapter(params) {
      return service.getNodeStatus(params);
    },
    async startNode(id) {
      const { data } = await service.startNode({ user_id: id });
      if (data) this.$toast.success('Обработка запущенна');
    },
    async stopNode(id) {
      const { data } = await service.stopNode({ user_id: id });
      if (data) this.$toast.success('Обработка завершена');
    },
    async refresh() {
      const { data } = await service.refreshNode();
      if (data) this.$toast.success('Обработка запущенна');
    },

  },
};
</script>
